module.exports = __webpack_public_path__ + "static/media/lightbulb-popup.4ef22e22.png";